
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[lang]/legal/threatening-behaviour-and-content",
      function () {
        return require("private-next-pages/[lang]/legal/threatening-behaviour-and-content/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[lang]/legal/threatening-behaviour-and-content"])
      });
    }
  